import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Loading from "./pages/loading";
import PlaneScroller from "./PlaneScroller";

const PageWrapper = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
      window.scrollTo(0, 0);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (loading) return <Loading />;

  return <PlaneScroller>{children}</PlaneScroller>;
};

export default PageWrapper;